import React from 'react'
import { cn } from '../../lib/utils'

export const ArticlesIcon = ({ className, width = 24, height = 24 }) => {
  const displayClass = cn('inline stroke-black', className)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={displayClass}
      role="img"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <title>Articles Icon</title>
      <path
        d="M10.5856 10.5858L16.9495 7.05029L13.414 13.4143L7.05005 16.9498L10.5856 10.5858Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const VideoIcon = ({ className }) => {
  const displayClass = cn('inline stroke-black', className)
  const height = 24
  const width = 24
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={displayClass}
      role="img"
      width={width}
      height={height}
      viewBox="0 0 75 75"
      fill="none"
    >
      <title>Videos and Audio Icon</title>
      <path
        d="M49.2188 32.8125L63.9687 18.0625C64.2965 17.7351 64.714 17.5122 65.1683 17.422C65.6227 17.3317 66.0936 17.3781 66.5216 17.5554C66.9496 17.7326 67.3155 18.0327 67.5731 18.4177C67.8307 18.8028 67.9683 19.2555 67.9688 19.7187V55.2813C67.9683 55.7445 67.8307 56.1972 67.5731 56.5823C67.3155 56.9673 66.9496 57.2674 66.5216 57.4446C66.0936 57.6219 65.6227 57.6683 65.1683 57.578C64.714 57.4878 64.2965 57.2649 63.9687 56.9375L49.2188 42.1875M14.0625 58.5938H42.1875C44.0523 58.5937 45.8407 57.853 47.1593 56.5343C48.478 55.2157 49.2188 53.4273 49.2188 51.5625V23.4375C49.2188 21.5727 48.478 19.7843 47.1593 18.4657C45.8407 17.147 44.0523 16.4063 42.1875 16.4062H14.0625C12.1977 16.4062 10.4093 17.147 9.09066 18.4657C7.77204 19.7843 7.03125 21.5727 7.03125 23.4375V51.5625C7.03125 53.4273 7.77204 55.2157 9.09066 56.5343C10.4093 57.853 12.1977 58.5938 14.0625 58.5938Z"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ShortCourseIcon = ({ className }) => {
  const displayClass = cn('inline stroke-black', className)
  const height = 24
  const width = 24
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={displayClass}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
    >
      <title>Short Course Icon</title>
      <path
        d="M20 30V20M20 20V5.6832C20 4.96528 20.734 4.48126 21.394 4.76406L35.4672 10.7955C36.2582 11.1344 36.2802 12.2476 35.5033 12.6175L20 20Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 36.6667C26.4433 36.6667 31.6666 34.055 31.6666 30.8333C31.6666 27.6117 26.4433 25 20 25C13.5567 25 8.33331 27.6117 8.33331 30.8333C8.33331 34.055 13.5567 36.6667 20 36.6667Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const AudioIcon = ({ className }) => {
  const displayClass = cn('inline stroke-black', className)
  const height = 24
  const width = 24
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={displayClass}
      role="img"
      width={width}
      height={height}
      viewBox="0 0 75 75"
      fill="none"
    >
      <path
        d="M59.7313 17.6124C62.343 20.224 64.4147 23.3245 65.8281 26.7368C67.2415 30.1491 67.969 33.8064 67.969 37.4999C67.969 41.1933 67.2415 44.8506 65.8281 48.2629C64.4147 51.6752 62.343 54.7757 59.7313 57.3874M51.4469 25.8999C54.5231 28.9766 56.2512 33.1492 56.2512 37.4999C56.2512 41.8506 54.5231 46.0232 51.4469 49.0999M21.0938 25.7811L35.8438 11.0311C36.1715 10.7038 36.589 10.4809 37.0433 10.3906C37.4977 10.3004 37.9686 10.3468 38.3967 10.524C38.8247 10.7012 39.1906 11.0013 39.4481 11.3864C39.7057 11.7714 39.8434 12.2241 39.8438 12.6874V62.3124C39.8434 62.7756 39.7057 63.2284 39.4481 63.6134C39.1906 63.9985 38.8247 64.2986 38.3967 64.4758C37.9686 64.653 37.4977 64.6994 37.0433 64.6092C36.589 64.5189 36.1715 64.296 35.8438 63.9686L21.0938 49.2186H14.0938C11.3438 49.2186 8.76876 47.6343 8.03751 44.9874C7.36722 42.5481 7.02876 40.0296 7.03126 37.4999C7.03126 34.9061 7.38126 32.3968 8.03751 30.0124C8.76876 27.3624 11.3438 25.7811 14.0938 25.7811H21.0938Z"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const AylaIcon = ({ className }) => {
  const displayClass = cn('inline stroke-black', className)
  const height = 24
  const width = 24
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={displayClass}
      role="img"
      width={width}
      height={height}
      viewBox="0 0 75 75"
      fill="none"
    >
      <title>Ayla Icon</title>
      <path
        d="M9.375 65.625L40.625 34.375M56.25 18.75L48.4375 26.5625"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.6875 6.25L32.6416 14.2334L40.625 17.1875L32.6416 20.1416L29.6875 28.125L26.7334 20.1416L18.75 17.1875L26.7334 14.2334L29.6875 6.25Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.375 31.25L61.0631 35.8119L65.625 37.5L61.0631 39.1881L59.375 43.75L57.6869 39.1881L53.125 37.5L57.6869 35.8119L59.375 31.25Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const QuizzesIcon = ({ className, stroke = 'black' }) => {
  const strokeClass = stroke === 'black' ? 'stroke-black' : `stroke-${stroke}`
  const displayClass = cn('inline', strokeClass, className)
  const height = 24
  const width = 24
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={displayClass}
      role="img"
      width={width}
      height={height}
      viewBox="0 0 75 75"
      fill="none"
    >
      <title>Quizzes Icon</title>
      <path
        d="M44.5312 19.0219C44.5312 17.9125 45.1125 16.9094 45.7844 16.025C46.475 15.1187 46.875 14.0437 46.875 12.8906C46.875 9.65312 43.7281 7.03125 39.8438 7.03125C35.9594 7.03125 32.8125 9.65625 32.8125 12.8906C32.8125 14.0437 33.2125 15.1187 33.9031 16.025C34.575 16.9094 35.1562 17.9125 35.1562 19.0219C35.1576 19.2898 35.1051 19.5553 35.0018 19.8026C34.8986 20.0499 34.7467 20.2739 34.5552 20.4613C34.3637 20.6487 34.1364 20.7958 33.887 20.8937C33.6376 20.9916 33.371 21.0384 33.1031 21.0313C28.7552 20.906 24.4147 20.5932 20.0937 20.0937C20.675 25.1344 21.0094 30.25 21.0781 35.4281C21.081 35.6997 21.0299 35.9691 20.9278 36.2208C20.8257 36.4725 20.6746 36.7013 20.4833 36.8941C20.292 37.0868 20.0643 37.2397 19.8134 37.3437C19.5625 37.4477 19.2935 37.5008 19.0219 37.5C17.9125 37.5 16.9094 36.9187 16.025 36.2469C15.1293 35.5472 14.0272 35.1637 12.8906 35.1562C9.65312 35.1562 7.03125 38.3031 7.03125 42.1875C7.03125 46.0719 9.65625 49.2188 12.8906 49.2188C14.0437 49.2188 15.1187 48.8188 16.025 48.1281C16.9094 47.4563 17.9125 46.875 19.0219 46.875C19.9906 46.875 20.7562 47.6875 20.6844 48.6562C20.2957 53.9547 19.626 59.2288 18.6781 64.4562C23.4219 65.05 28.2344 65.4219 33.1031 65.5625C33.371 65.5696 33.6376 65.5228 33.887 65.4249C34.1364 65.327 34.3637 65.18 34.5552 64.9926C34.7467 64.8051 34.8986 64.5811 35.0018 64.3339C35.1051 64.0866 35.1576 63.8211 35.1562 63.5531C35.1562 62.4437 34.575 61.4406 33.9031 60.5563C33.2035 59.6605 32.82 58.5584 32.8125 57.4219C32.8125 54.1875 35.9625 51.5625 39.8438 51.5625C43.7281 51.5625 46.875 54.1875 46.875 57.4219C46.875 58.575 46.475 59.65 45.7844 60.5563C45.1125 61.4406 44.5344 62.4437 44.5344 63.5531C44.5344 64.5937 45.4 65.425 46.4406 65.3656C52.1265 65.0312 57.7887 64.3739 63.4 63.3969C64.249 58.5163 64.856 53.5968 65.2188 48.6562C65.2351 48.4279 65.2041 48.1986 65.1277 47.9828C65.0513 47.7669 64.9312 47.5692 64.7748 47.402C64.6184 47.2348 64.4292 47.1016 64.219 47.011C64.0088 46.9203 63.7821 46.874 63.5531 46.875C62.4437 46.875 61.4406 47.4563 60.5563 48.1281C59.65 48.8188 58.575 49.2188 57.4219 49.2188C54.1875 49.2188 51.5625 46.0719 51.5625 42.1875C51.5625 38.3031 54.1875 35.1562 57.4219 35.1562C58.5781 35.1562 59.65 35.5562 60.5563 36.2469C61.4406 36.9187 62.4437 37.5 63.5562 37.5C63.8278 37.5008 64.0969 37.4477 64.3478 37.3437C64.5986 37.2397 64.8264 37.0868 65.0177 36.8941C65.209 36.7013 65.3601 36.4725 65.4622 36.2208C65.5643 35.9691 65.6154 35.6997 65.6125 35.4281C65.5374 29.8277 65.1514 24.2358 64.4562 18.6781C58.5625 19.7469 52.55 20.4719 46.4375 20.8312C46.1915 20.8449 45.9453 20.8081 45.7141 20.723C45.4828 20.638 45.2714 20.5065 45.0929 20.3368C44.9143 20.167 44.7724 19.9625 44.6758 19.7358C44.5792 19.5092 44.53 19.2683 44.5312 19.0219Z"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const CompletedIcon = ({ className }) => {
  const displayClass = cn('inline stroke-black', className)
  const height = 24
  const width = 24
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={displayClass}
      role="img"
      width={width}
      height={height}
      viewBox="0 0 75 75"
      fill="none"
    >
      <title>Completed Icon</title>
      <path
        d="M28.125 39.8438L35.1563 46.875L46.875 30.4688M65.625 37.5C65.625 41.4625 63.6563 44.9688 60.6469 47.0875C60.9711 48.9399 60.8442 50.8432 60.2768 52.6361C59.7094 54.429 58.7184 56.0588 57.3875 57.3875C56.0588 58.7184 54.429 59.7094 52.6361 60.2768C50.8432 60.8442 48.9399 60.9711 47.0875 60.6469C46.0069 62.1859 44.5714 63.4418 42.9025 64.3084C41.2336 65.1749 39.3805 65.6265 37.5 65.625C33.5375 65.625 30.0313 63.6562 27.9125 60.6469C26.0601 60.9708 24.1569 60.8438 22.364 60.2764C20.5711 59.7091 18.9413 58.7181 17.6125 57.3875C16.2816 56.0588 15.2906 54.429 14.7232 52.6361C14.1558 50.8432 14.0289 48.9399 14.3531 47.0875C12.8141 46.0069 11.5582 44.5714 10.6916 42.9025C9.8251 41.2336 9.37347 39.3805 9.375 37.5C9.375 33.5375 11.3438 30.0313 14.3531 27.9125C14.0289 26.0601 14.1558 24.1568 14.7232 22.3639C15.2906 20.571 16.2816 18.9412 17.6125 17.6125C18.9413 16.2819 20.5711 15.2909 22.364 14.7236C24.1569 14.1562 26.0601 14.0292 27.9125 14.3531C28.9933 12.8143 30.4288 11.5585 32.0977 10.692C33.7665 9.82548 35.6196 9.37373 37.5 9.375C41.4625 9.375 44.9688 11.3438 47.0875 14.3531C48.9399 14.0292 50.8431 14.1562 52.636 14.7236C54.4289 15.2909 56.0587 16.2819 57.3875 17.6125C58.7181 18.9413 59.7091 20.5711 60.2764 22.364C60.8438 24.1569 60.9708 26.0601 60.6469 27.9125C62.1859 28.9931 63.4418 30.4286 64.3084 32.0975C65.1749 33.7664 65.6265 35.6195 65.625 37.5Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ExercisesIcon = ({ className }) => {
  const displayClass = cn('inline stroke-black', className)
  const height = 24
  const width = 24
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={displayClass}
      role="img"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <title>Exercises Icon</title>
      <path
        d="M5 19C7.20914 19 9 17.2091 9 15C9 12.7909 7.20914 11 5 11C2.79086 11 1 12.7909 1 15C1 17.2091 2.79086 19 5 19Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 7.5H14.5M14.5 7.5H15L19 15M14.5 7.5L16.5 4.5M16.5 4.5H14M16.5 4.5H18.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 15L8.5 7.5L12 14H15"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 7.5C8.16667 6.5 7 4.5 5 4.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 19C21.2091 19 23 17.2091 23 15C23 12.7909 21.2091 11 19 11C16.7909 11 15 12.7909 15 15C15 17.2091 16.7909 19 19 19Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const WebinarsIcon = ({ className }) => {
  const displayClass = cn('inline stroke-black', className)
  const height = 24
  const width = 24
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={displayClass}
      role="img"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <title>Webinars Icon</title>
      <path
        d="M9 17.25V18.257C9.00005 18.6511 8.92244 19.0414 8.77162 19.4055C8.6208 19.7696 8.39971 20.1004 8.121 20.379L7.5 21H16.5L15.879 20.379C15.6003 20.1004 15.3792 19.7696 15.2284 19.4055C15.0776 19.0414 15 18.6511 15 18.257V17.25M21 5.25V15C21 15.5967 20.7629 16.169 20.341 16.591C19.919 17.0129 19.3467 17.25 18.75 17.25H5.25C4.65326 17.25 4.08097 17.0129 3.65901 16.591C3.23705 16.169 3 15.5967 3 15V5.25M21 5.25C21 4.65326 20.7629 4.08097 20.341 3.65901C19.919 3.23705 19.3467 3 18.75 3H5.25C4.65326 3 4.08097 3.23705 3.65901 3.65901C3.23705 4.08097 3 4.65326 3 5.25M21 5.25V12C21 12.5967 20.7629 13.169 20.341 13.591C19.919 14.0129 19.3467 14.25 18.75 14.25H5.25C4.65326 14.25 4.08097 14.0129 3.65901 13.591C3.23705 13.169 3 12.5967 3 12V5.25"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const FavoriteIcon = ({
  className,
  width = 24,
  height = 24,
  title = '',
}) => {
  const displayClass = cn('inline stroke-black', className)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={displayClass}
      role="img"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <title>{title}</title>
      <path
        d="M17.593 3.32206C18.693 3.45006 19.5 4.39906 19.5 5.50706V21.0001L12 17.2501L4.5 21.0001V5.50706C4.5 4.39906 5.306 3.45006 6.407 3.32206C10.1232 2.89069 13.8768 2.89069 17.593 3.32206Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const AssessmentsIcon = ({ className }) => {
  const displayClass = cn('inline stroke-black', className)
  const height = 24
  const width = 24
  const strokeWidth = '4.5'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={displayClass}
      role="img"
      width={width}
      height={height}
      viewBox="0 0 75 75"
      fill="none"
    >
      <title>Assessments Icon</title>
      <path
        d="M21.875 43.75C16.6973 43.75 12.5 47.9472 12.5 53.125C12.5 58.3028 16.6973 62.5 21.875 62.5C22.9707 62.5 24.0226 62.3119 25 61.9666"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3246 48.7646C9.13831 46.7446 6.25 42.4596 6.25 37.5003C6.25 33.7137 7.93353 30.3206 10.5929 28.0283"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6892 27.7756C9.85906 26.5347 9.375 25.0426 9.375 23.4375C9.375 19.1228 12.8728 15.625 17.1875 15.625C18.9466 15.625 20.5699 16.2064 21.8757 17.1875"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6178 17.3917C22.1414 16.3817 21.875 15.2532 21.875 14.0625C21.875 9.74778 25.3728 6.25 29.6875 6.25C34.0022 6.25 37.5 9.74778 37.5 14.0625V62.5"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 62.5C25 65.9519 27.7982 68.75 31.25 68.75C34.7019 68.75 37.5 65.9519 37.5 62.5"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5 21.875C37.5 27.0527 41.6972 31.25 46.875 31.25"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.4067 28.0283C67.0661 30.3206 68.7499 33.7137 68.7499 37.5003C68.7499 39.6974 68.183 41.7621 67.1874 43.5562"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.3111 27.7756C65.1411 26.5347 65.6251 25.0426 65.6251 23.4375C65.6251 19.1228 62.1273 15.625 57.8126 15.625C56.0536 15.625 54.4301 16.2064 53.1245 17.1875"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5 14.0625C37.5 9.74778 40.9978 6.25 45.3125 6.25C49.6272 6.25 53.125 9.74778 53.125 14.0625C53.125 15.2532 52.8588 16.3817 52.3822 17.3917"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.75 68.75C40.2981 68.75 37.5 65.9519 37.5 62.5"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.0625 64.0625L68.75 68.75"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 57.8125C50 62.1272 53.4978 65.625 57.8125 65.625C59.9738 65.625 61.9297 64.7475 63.3441 63.3294C64.7534 61.9162 65.625 59.9662 65.625 57.8125C65.625 53.4978 62.1272 50 57.8125 50C53.4978 50 50 53.4978 50 57.8125Z"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const CheckMarkIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={cn('size-6', className)}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m4.5 12.75 6 6 9-13.5"
      />
    </svg>
  )
}

export const ScriptsIcon = ({ className }) => {
  const displayClass = cn('inline stroke-black', className)
  const height = 24
  const width = 24
  return (
    <svg
      className={displayClass}
      width={width}
      height={height}
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Scripts Icon</title>
      <path
        d="M3 20.2895V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V15C21 16.1046 20.1046 17 19 17H7.96125C7.35368 17 6.77906 17.2762 6.39951 17.7506L4.06852 20.6643C3.71421 21.1072 3 20.8567 3 20.2895Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M10.5 10H8.5C7.94772 10 7.5 9.55228 7.5 9V8C7.5 7.44772 7.94772 7 8.5 7H9.5C10.0523 7 10.5 7.44772 10.5 8V10ZM10.5 10C10.5 11 9.5 12 8.5 13"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M16.5 10H14.5C13.9477 10 13.5 9.55228 13.5 9V8C13.5 7.44772 13.9477 7 14.5 7H15.5C16.0523 7 16.5 7.44772 16.5 8V10ZM16.5 10C16.5 11 15.5 12 14.5 13"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  )
}

export const ClockIcon = ({
  className = 'stroke-black',
  width = 24,
  height = 24,
  strokeWidth = '1',
}) => {
  let displayClass = 'inline'
  if (className) {
    displayClass += ' '
    displayClass += className
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={displayClass}
      role="img"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      />
    </svg>
  )
}

export const ChecklistIcon = ({ className }) => {
  const displayClass = cn('inline stroke-black', className)
  const height = 24
  const width = 24
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={displayClass}
      role="img"
      width={width}
      height={height}
      viewBox="0 0 75 75"
      fill="none"
    >
      <title>Checklist Icon</title>
      <path
        d="M35.4688 11.9875C35.2656 12.6437 35.1562 13.3406 35.1562 14.0625C35.1562 15.3563 36.2062 16.4062 37.5 16.4062H51.5625C52.1841 16.4062 52.7802 16.1593 53.2198 15.7198C53.6593 15.2802 53.9062 14.6841 53.9062 14.0625C53.9065 13.3591 53.8011 12.6596 53.5937 11.9875M35.4688 11.9875C35.9126 10.5522 36.8043 9.29667 38.0133 8.40481C39.2223 7.51295 40.6851 7.0316 42.1875 7.03125H46.875C50.0375 7.03125 52.7094 9.11875 53.5937 11.9875M35.4688 11.9875C34.2938 12.0594 33.125 12.1437 31.9562 12.2375C28.4219 12.5312 25.7812 15.5406 25.7812 19.0875V25.7812M53.5937 11.9875C54.7687 12.0594 55.9375 12.1437 57.1063 12.2375C60.6406 12.5312 63.2812 15.5406 63.2812 19.0875V51.5625C63.2812 53.4273 62.5405 55.2157 61.2218 56.5343C59.9032 57.853 58.1148 58.5938 56.25 58.5938H49.2188M25.7812 25.7812H15.2344C13.2938 25.7812 11.7188 27.3563 11.7188 29.2969V64.4531C11.7188 66.3937 13.2938 67.9688 15.2344 67.9688H45.7031C47.6437 67.9688 49.2188 66.3937 49.2188 64.4531V58.5938M25.7812 25.7812H45.7031C47.6437 25.7812 49.2188 27.3563 49.2188 29.2969V58.5938M23.4375 49.2188L28.125 53.9062L37.5 42.1875"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
